
import { Validatable } from "../mixins/validatable";
import {toFixedWithPrecision} from "../utils";

export default Validatable.extend({
	inheritAttrs: true,
	data() {
		return {
			focused: false,
			resetTriggered: false,
			isNegative: false,
			calculatedValue: 0.0
		};
	},
	props: {
		value: {
			type: Number,
			default: 0
		},
		decimals: {
			type: Number,
			default: 2
		},
		calculatedDecimals: {
			type: Number,
			default: 8
		},
		min: {
			type: [Number, String]
		},
		max: {
			type: [Number, String]
		},
		tabindex: [Number, String],
		preventTab: Boolean,
		hasError: Boolean,
		icon: String,
		iconLeft: String,
		forceNumber: Boolean,
		step: Number,
		currency: Number,
		currencyRate: Number,
		autofocus: Boolean
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.calculateValue();
				if (this.value == 0) return;
				this.isNegative = this.value < 0;
			}
		}
	},
	computed: {
		minValue():number | undefined {
			if (this.min == undefined) {
				return undefined;
			}
			if (typeof(this.min)=="string") {
				return parseInt(this.min);
			}
			return this.min;
		},
		maxValue():number | undefined {
			if (this.max == undefined) {
				return undefined;
			}
			if (typeof(this.max)=="string") {
				return parseInt(this.max);
			}
			return this.max;
		},
		negative():Boolean {
			if (this.minValue == undefined) {
				return true;
			}
			if (this.minValue >= 0) {
				return false;
			}
			return true;
		},
		listeners():any {
			let listeners = {...this.$listeners};
			delete listeners.input;
			return listeners;
		},
		text():string | number {
			if (this.focused && isNaN(this.value)){
				if (this.isNegative){
					return "-";
				}
				return "";
			}
			if (this.value == 0 && this.isNegative){
				return "-";
			}
			if (this.resetTriggered) {
				return `${this.value}`;
			}
			return toFixedWithPrecision(this.value || 0,this.decimals);
		},
		pattern():RegExp {
			if (this.calculatedDecimals == 0) {
				return /^\-?[0-9]*$/;
			}
			return new RegExp(`^\\-?[0-9]*([\\.\\,]([0-9]{0,${this.calculatedDecimals}})*)?$`);
		},
		iconClickHandler():Function | undefined {
			return this.$listeners["icon-click"] as Function || undefined;
		},
		iconLeftClickHandler():Function | undefined {
			return this.$listeners["icon-click"] as Function || undefined;
		}
	},
	methods: {
		onFocus() {
			this.focused = true;
		},
		onBlur(){
			this.focused = false;
			this.calculateValue();
		},
		blur(){
			if (!this.$refs.inputElement) return;
			(this.$refs.inputElement as any).blur();
		},
		onInput(event: number) {
			this.calculatedValue = event;
			this.$emit("input", event * this.currencyRate);
		},
		focus() {
			(this.$refs.inputElement as HTMLInputElement).focus();
		},
		calculateValue(){
			if (this.focused) return;
			this.calculatedValue = this.currency > 1 ? this.value / this.currencyRate : this.value;
		}
	},
	mounted(){
		this.calculateValue();
	}
});
